export const timezone = [
  {
    title: "Pacific/Midway (GMT-11:00)",
    value: "Pacific/Midway",
  },
  {
    title: "Pacific/Niue (GMT-11:00)",
    value: "Pacific/Niue",
  },
  {
    title: "Pacific/Pago_Pago (GMT-11:00)",
    value: "Pacific/Pago_Pago",
  },
  {
    title: "America/Adak (GMT-10:00)",
    value: "America/Adak",
  },
  {
    title: "Pacific/Honolulu (GMT-10:00)",
    value: "Pacific/Honolulu",
  },
  {
    title: "Pacific/Rarotonga (GMT-10:00)",
    value: "Pacific/Rarotonga",
  },
  {
    title: "Pacific/Tahiti (GMT-10:00)",
    value: "Pacific/Tahiti",
  },
  {
    title: "Pacific/Marquesas (GMT-09:30)",
    value: "Pacific/Marquesas",
  },
  {
    title: "America/Anchorage (GMT-09:00)",
    value: "America/Anchorage",
  },
  {
    title: "America/Juneau (GMT-09:00)",
    value: "America/Juneau",
  },
  {
    title: "America/Metlakatla (GMT-09:00)",
    value: "America/Metlakatla",
  },
  {
    title: "America/Nome (GMT-09:00)",
    value: "America/Nome",
  },
  {
    title: "America/Sitka (GMT-09:00)",
    value: "America/Sitka",
  },
  {
    title: "America/Yakutat (GMT-09:00)",
    value: "America/Yakutat",
  },
  {
    title: "Pacific/Gambier (GMT-09:00)",
    value: "Pacific/Gambier",
  },
  {
    title: "America/Los_Angeles (GMT-08:00)",
    value: "America/Los_Angeles",
  },
  {
    title: "America/Tijuana (GMT-08:00)",
    value: "America/Tijuana",
  },
  {
    title: "America/Vancouver (GMT-08:00)",
    value: "America/Vancouver",
  },
  {
    title: "Pacific/Pitcairn (GMT-08:00)",
    value: "Pacific/Pitcairn",
  },
  {
    title: "America/Boise (GMT-07:00)",
    value: "America/Boise",
  },
  {
    title: "America/Cambridge_Bay (GMT-07:00)",
    value: "America/Cambridge_Bay",
  },
  {
    title: "America/Chihuahua (GMT-07:00)",
    value: "America/Chihuahua",
  },
  {
    title: "America/Creston (GMT-07:00)",
    value: "America/Creston",
  },
  {
    title: "America/Dawson (GMT-07:00)",
    value: "America/Dawson",
  },
  {
    title: "America/Dawson_Creek (GMT-07:00)",
    value: "America/Dawson_Creek",
  },
  {
    title: "America/Denver (GMT-07:00)",
    value: "America/Denver",
  },
  {
    title: "America/Edmonton (GMT-07:00)",
    value: "America/Edmonton",
  },
  {
    title: "America/Fort_Nelson (GMT-07:00)",
    value: "America/Fort_Nelson",
  },
  {
    title: "America/Hermosillo (GMT-07:00)",
    value: "America/Hermosillo",
  },
  {
    title: "America/Inuvik (GMT-07:00)",
    value: "America/Inuvik",
  },
  {
    title: "America/Mazatlan (GMT-07:00)",
    value: "America/Mazatlan",
  },
  {
    title: "America/Ojinaga (GMT-07:00)",
    value: "America/Ojinaga",
  },
  {
    title: "America/Phoenix (GMT-07:00)",
    value: "America/Phoenix",
  },
  {
    title: "America/Whitehorse (GMT-07:00)",
    value: "America/Whitehorse",
  },
  {
    title: "America/Yellowknife (GMT-07:00)",
    value: "America/Yellowknife",
  },
  {
    title: "America/Bahia_Banderas (GMT-06:00)",
    value: "America/Bahia_Banderas",
  },
  {
    title: "America/Belize (GMT-06:00)",
    value: "America/Belize",
  },
  {
    title: "America/Chicago (GMT-06:00)",
    value: "America/Chicago",
  },
  {
    title: "America/Costa_Rica (GMT-06:00)",
    value: "America/Costa_Rica",
  },
  {
    title: "America/El_Salvador (GMT-06:00)",
    value: "America/El_Salvador",
  },
  {
    title: "America/Guatemala (GMT-06:00)",
    value: "America/Guatemala",
  },
  {
    title: "America/Indiana/Knox (GMT-06:00)",
    value: "America/Indiana/Knox",
  },
  {
    title: "America/Indiana/Tell_City (GMT-06:00)",
    value: "America/Indiana/Tell_City",
  },
  {
    title: "America/Managua (GMT-06:00)",
    value: "America/Managua",
  },
  {
    title: "America/Matamoros (GMT-06:00)",
    value: "America/Matamoros",
  },
  {
    title: "America/Menominee (GMT-06:00)",
    value: "America/Menominee",
  },
  {
    title: "America/Merida (GMT-06:00)",
    value: "America/Merida",
  },
  {
    title: "America/Mexico_City (GMT-06:00)",
    value: "America/Mexico_City",
  },
  {
    title: "America/Monterrey (GMT-06:00)",
    value: "America/Monterrey",
  },
  {
    title: "America/North_Dakota/Beulah (GMT-06:00)",
    value: "America/North_Dakota/Beulah",
  },
  {
    title: "America/North_Dakota/Center (GMT-06:00)",
    value: "America/North_Dakota/Center",
  },
  {
    title: "America/North_Dakota/New_Salem (GMT-06:00)",
    value: "America/North_Dakota/New_Salem",
  },
  {
    title: "America/Rainy_River (GMT-06:00)",
    value: "America/Rainy_River",
  },
  {
    title: "America/Rankin_Inlet (GMT-06:00)",
    value: "America/Rankin_Inlet",
  },
  {
    title: "America/Regina (GMT-06:00)",
    value: "America/Regina",
  },
  {
    title: "America/Resolute (GMT-06:00)",
    value: "America/Resolute",
  },
  {
    title: "America/Swift_Current (GMT-06:00)",
    value: "America/Swift_Current",
  },
  {
    title: "America/Tegucigalpa (GMT-06:00)",
    value: "America/Tegucigalpa",
  },
  {
    title: "America/Winnipeg (GMT-06:00)",
    value: "America/Winnipeg",
  },
  {
    title: "Pacific/Easter (GMT-06:00)",
    value: "Pacific/Easter",
  },
  {
    title: "Pacific/Galapagos (GMT-06:00)",
    value: "Pacific/Galapagos",
  },
  {
    title: "America/Atikokan (GMT-05:00)",
    value: "America/Atikokan",
  },
  {
    title: "America/Bogota (GMT-05:00)",
    value: "America/Bogota",
  },
  {
    title: "America/Cancun (GMT-05:00)",
    value: "America/Cancun",
  },
  {
    title: "America/Cayman (GMT-05:00)",
    value: "America/Cayman",
  },
  {
    title: "America/Detroit (GMT-05:00)",
    value: "America/Detroit",
  },
  {
    title: "America/Eirunepe (GMT-05:00)",
    value: "America/Eirunepe",
  },
  {
    title: "America/Grand_Turk (GMT-05:00)",
    value: "America/Grand_Turk",
  },
  {
    title: "America/Guayaquil (GMT-05:00)",
    value: "America/Guayaquil",
  },
  {
    title: "America/Havana (GMT-05:00)",
    value: "America/Havana",
  },
  {
    title: "America/Indiana/Indianapolis (GMT-05:00)",
    value: "America/Indiana/Indianapolis",
  },
  {
    title: "America/Indiana/Marengo (GMT-05:00)",
    value: "America/Indiana/Marengo",
  },
  {
    title: "America/Indiana/Petersburg (GMT-05:00)",
    value: "America/Indiana/Petersburg",
  },
  {
    title: "America/Indiana/Vevay (GMT-05:00)",
    value: "America/Indiana/Vevay",
  },
  {
    title: "America/Indiana/Vincennes (GMT-05:00)",
    value: "America/Indiana/Vincennes",
  },
  {
    title: "America/Indiana/Winamac (GMT-05:00)",
    value: "America/Indiana/Winamac",
  },
  {
    title: "America/Iqaluit (GMT-05:00)",
    value: "America/Iqaluit",
  },
  {
    title: "America/Jamaica (GMT-05:00)",
    value: "America/Jamaica",
  },
  {
    title: "America/Kentucky/Louisville (GMT-05:00)",
    value: "America/Kentucky/Louisville",
  },
  {
    title: "America/Kentucky/Monticello (GMT-05:00)",
    value: "America/Kentucky/Monticello",
  },
  {
    title: "America/Lima (GMT-05:00)",
    value: "America/Lima",
  },
  {
    title: "America/Nassau (GMT-05:00)",
    value: "America/Nassau",
  },
  {
    title: "America/New_York (GMT-05:00)",
    value: "America/New_York",
  },
  {
    title: "America/Nipigon (GMT-05:00)",
    value: "America/Nipigon",
  },
  {
    title: "America/Panama (GMT-05:00)",
    value: "America/Panama",
  },
  {
    title: "America/Pangnirtung (GMT-05:00)",
    value: "America/Pangnirtung",
  },
  {
    title: "America/Port-au-Prince (GMT-05:00)",
    value: "America/Port-au-Prince",
  },
  {
    title: "America/Rio_Branco (GMT-05:00)",
    value: "America/Rio_Branco",
  },
  {
    title: "America/Thunder_Bay (GMT-05:00)",
    value: "America/Thunder_Bay",
  },
  {
    title: "America/Toronto (GMT-05:00)",
    value: "America/Toronto",
  },
  {
    title: "America/Anguilla (GMT-04:00)",
    value: "America/Anguilla",
  },
  {
    title: "America/Antigua (GMT-04:00)",
    value: "America/Antigua",
  },
  {
    title: "America/Aruba (GMT-04:00)",
    value: "America/Aruba",
  },
  {
    title: "America/Asuncion (GMT-04:00)",
    value: "America/Asuncion",
  },
  {
    title: "America/Barbados (GMT-04:00)",
    value: "America/Barbados",
  },
  {
    title: "America/Blanc-Sablon (GMT-04:00)",
    value: "America/Blanc-Sablon",
  },
  {
    title: "America/Boa_Vista (GMT-04:00)",
    value: "America/Boa_Vista",
  },
  {
    title: "America/Campo_Grande (GMT-04:00)",
    value: "America/Campo_Grande",
  },
  {
    title: "America/Caracas (GMT-04:00)",
    value: "America/Caracas",
  },
  {
    title: "America/Cuiaba (GMT-04:00)",
    value: "America/Cuiaba",
  },
  {
    title: "America/Curacao (GMT-04:00)",
    value: "America/Curacao",
  },
  {
    title: "America/Dominica (GMT-04:00)",
    value: "America/Dominica",
  },
  {
    title: "America/Glace_Bay (GMT-04:00)",
    value: "America/Glace_Bay",
  },
  {
    title: "America/Goose_Bay (GMT-04:00)",
    value: "America/Goose_Bay",
  },
  {
    title: "America/Grenada (GMT-04:00)",
    value: "America/Grenada",
  },
  {
    title: "America/Guadeloupe (GMT-04:00)",
    value: "America/Guadeloupe",
  },
  {
    title: "America/Guyana (GMT-04:00)",
    value: "America/Guyana",
  },
  {
    title: "America/Halifax (GMT-04:00)",
    value: "America/Halifax",
  },
  {
    title: "America/Kralendijk (GMT-04:00)",
    value: "America/Kralendijk",
  },
  {
    title: "America/La_Paz (GMT-04:00)",
    value: "America/La_Paz",
  },
  {
    title: "America/Lower_Princes (GMT-04:00)",
    value: "America/Lower_Princes",
  },
  {
    title: "America/Manaus (GMT-04:00)",
    value: "America/Manaus",
  },
  {
    title: "America/Marigot (GMT-04:00)",
    value: "America/Marigot",
  },
  {
    title: "America/Martinique (GMT-04:00)",
    value: "America/Martinique",
  },
  {
    title: "America/Moncton (GMT-04:00)",
    value: "America/Moncton",
  },
  {
    title: "America/Montserrat (GMT-04:00)",
    value: "America/Montserrat",
  },
  {
    title: "America/Porto_Velho (GMT-04:00)",
    value: "America/Porto_Velho",
  },
  {
    title: "America/Port_of_Spain (GMT-04:00)",
    value: "America/Port_of_Spain",
  },
  {
    title: "America/Puerto_Rico (GMT-04:00)",
    value: "America/Puerto_Rico",
  },
  {
    title: "America/Santiago (GMT-04:00)",
    value: "America/Santiago",
  },
  {
    title: "America/Santo_Domingo (GMT-04:00)",
    value: "America/Santo_Domingo",
  },
  {
    title: "America/St_Barthelemy (GMT-04:00)",
    value: "America/St_Barthelemy",
  },
  {
    title: "America/St_Kitts (GMT-04:00)",
    value: "America/St_Kitts",
  },
  {
    title: "America/St_Lucia (GMT-04:00)",
    value: "America/St_Lucia",
  },
  {
    title: "America/St_Thomas (GMT-04:00)",
    value: "America/St_Thomas",
  },
  {
    title: "America/St_Vincent (GMT-04:00)",
    value: "America/St_Vincent",
  },
  {
    title: "America/Thule (GMT-04:00)",
    value: "America/Thule",
  },
  {
    title: "America/Tortola (GMT-04:00)",
    value: "America/Tortola",
  },
  {
    title: "Atlantic/Bermuda (GMT-04:00)",
    value: "Atlantic/Bermuda",
  },
  {
    title: "America/St_Johns (GMT-03:30)",
    value: "America/St_Johns",
  },
  {
    title: "America/Araguaina (GMT-03:00)",
    value: "America/Araguaina",
  },
  {
    title: "America/Argentina/Buenos_Aires (GMT-03:00)",
    value: "America/Argentina/Buenos_Aires",
  },
  {
    title: "America/Argentina/Catamarca (GMT-03:00)",
    value: "America/Argentina/Catamarca",
  },
  {
    title: "America/Argentina/Cordoba (GMT-03:00)",
    value: "America/Argentina/Cordoba",
  },
  {
    title: "America/Argentina/Jujuy (GMT-03:00)",
    value: "America/Argentina/Jujuy",
  },
  {
    title: "America/Argentina/La_Rioja (GMT-03:00)",
    value: "America/Argentina/La_Rioja",
  },
  {
    title: "America/Argentina/Mendoza (GMT-03:00)",
    value: "America/Argentina/Mendoza",
  },
  {
    title: "America/Argentina/Rio_Gallegos (GMT-03:00)",
    value: "America/Argentina/Rio_Gallegos",
  },
  {
    title: "America/Argentina/Salta (GMT-03:00)",
    value: "America/Argentina/Salta",
  },
  {
    title: "America/Argentina/San_Juan (GMT-03:00)",
    value: "America/Argentina/San_Juan",
  },
  {
    title: "America/Argentina/San_Luis (GMT-03:00)",
    value: "America/Argentina/San_Luis",
  },
  {
    title: "America/Argentina/Tucuman (GMT-03:00)",
    value: "America/Argentina/Tucuman",
  },
  {
    title: "America/Argentina/Ushuaia (GMT-03:00)",
    value: "America/Argentina/Ushuaia",
  },
  {
    title: "America/Bahia (GMT-03:00)",
    value: "America/Bahia",
  },
  {
    title: "America/Belem (GMT-03:00)",
    value: "America/Belem",
  },
  {
    title: "America/Cayenne (GMT-03:00)",
    value: "America/Cayenne",
  },
  {
    title: "America/Fortaleza (GMT-03:00)",
    value: "America/Fortaleza",
  },
  {
    title: "America/Godthab (GMT-03:00)",
    value: "America/Godthab",
  },
  {
    title: "America/Maceio (GMT-03:00)",
    value: "America/Maceio",
  },
  {
    title: "America/Miquelon (GMT-03:00)",
    value: "America/Miquelon",
  },
  {
    title: "America/Montevideo (GMT-03:00)",
    value: "America/Montevideo",
  },
  {
    title: "America/Paramaribo (GMT-03:00)",
    value: "America/Paramaribo",
  },
  {
    title: "America/Punta_Arenas (GMT-03:00)",
    value: "America/Punta_Arenas",
  },
  {
    title: "America/Recife (GMT-03:00)",
    value: "America/Recife",
  },
  {
    title: "America/Santarem (GMT-03:00)",
    value: "America/Santarem",
  },
  {
    title: "America/Sao_Paulo (GMT-03:00)",
    value: "America/Sao_Paulo",
  },
  {
    title: "Antarctica/Palmer (GMT-03:00)",
    value: "Antarctica/Palmer",
  },
  {
    title: "Antarctica/Rothera (GMT-03:00)",
    value: "Antarctica/Rothera",
  },
  {
    title: "Atlantic/Stanley (GMT-03:00)",
    value: "Atlantic/Stanley",
  },
  {
    title: "America/Noronha (GMT-02:00)",
    value: "America/Noronha",
  },
  {
    title: "Atlantic/South_Georgia (GMT-02:00)",
    value: "Atlantic/South_Georgia",
  },
  {
    title: "America/Scoresbysund (GMT-01:00)",
    value: "America/Scoresbysund",
  },
  {
    title: "Atlantic/Azores (GMT-01:00)",
    value: "Atlantic/Azores",
  },
  {
    title: "Atlantic/Cape_Verde (GMT-01:00)",
    value: "Atlantic/Cape_Verde",
  },
  {
    title: "Africa/Abidjan (GMT+00:00)",
    value: "Africa/Abidjan",
  },
  {
    title: "Africa/Accra (GMT+00:00)",
    value: "Africa/Accra",
  },
  {
    title: "Africa/Bamako (GMT+00:00)",
    value: "Africa/Bamako",
  },
  {
    title: "Africa/Banjul (GMT+00:00)",
    value: "Africa/Banjul",
  },
  {
    title: "Africa/Bissau (GMT+00:00)",
    value: "Africa/Bissau",
  },
  {
    title: "Africa/Casablanca (GMT+00:00)",
    value: "Africa/Casablanca",
  },
  {
    title: "Africa/Conakry (GMT+00:00)",
    value: "Africa/Conakry",
  },
  {
    title: "Africa/Dakar (GMT+00:00)",
    value: "Africa/Dakar",
  },
  {
    title: "Africa/El_Aaiun (GMT+00:00)",
    value: "Africa/El_Aaiun",
  },
  {
    title: "Africa/Freetown (GMT+00:00)",
    value: "Africa/Freetown",
  },
  {
    title: "Africa/Lome (GMT+00:00)",
    value: "Africa/Lome",
  },
  {
    title: "Africa/Monrovia (GMT+00:00)",
    value: "Africa/Monrovia",
  },
  {
    title: "Africa/Nouakchott (GMT+00:00)",
    value: "Africa/Nouakchott",
  },
  {
    title: "Africa/Ouagadougou (GMT+00:00)",
    value: "Africa/Ouagadougou",
  },
  {
    title: "Africa/Sao_Tome (GMT+00:00)",
    value: "Africa/Sao_Tome",
  },
  {
    title: "America/Danmarkshavn (GMT+00:00)",
    value: "America/Danmarkshavn",
  },
  {
    title: "Antarctica/Troll (GMT+00:00)",
    value: "Antarctica/Troll",
  },
  {
    title: "Atlantic/Canary (GMT+00:00)",
    value: "Atlantic/Canary",
  },
  {
    title: "Atlantic/Faroe (GMT+00:00)",
    value: "Atlantic/Faroe",
  },
  {
    title: "Atlantic/Madeira (GMT+00:00)",
    value: "Atlantic/Madeira",
  },
  {
    title: "Atlantic/Reykjavik (GMT+00:00)",
    value: "Atlantic/Reykjavik",
  },
  {
    title: "Atlantic/St_Helena (GMT+00:00)",
    value: "Atlantic/St_Helena",
  },
  {
    title: "Europe/Dublin (GMT+00:00)",
    value: "Europe/Dublin",
  },
  {
    title: "Europe/Guernsey (GMT+00:00)",
    value: "Europe/Guernsey",
  },
  {
    title: "Europe/Isle_of_Man (GMT+00:00)",
    value: "Europe/Isle_of_Man",
  },
  {
    title: "Europe/Jersey (GMT+00:00)",
    value: "Europe/Jersey",
  },
  {
    title: "Europe/Lisbon (GMT+00:00)",
    value: "Europe/Lisbon",
  },
  {
    title: "Europe/London (GMT+00:00)",
    value: "Europe/London",
  },
  {
    title: "Africa/Algiers (GMT+01:00)",
    value: "Africa/Algiers",
  },
  {
    title: "Africa/Bangui (GMT+01:00)",
    value: "Africa/Bangui",
  },
  {
    title: "Africa/Brazzaville (GMT+01:00)",
    value: "Africa/Brazzaville",
  },
  {
    title: "Africa/Ceuta (GMT+01:00)",
    value: "Africa/Ceuta",
  },
  {
    title: "Africa/Douala (GMT+01:00)",
    value: "Africa/Douala",
  },
  {
    title: "Africa/Kinshasa (GMT+01:00)",
    value: "Africa/Kinshasa",
  },
  {
    title: "Africa/Lagos (GMT+01:00)",
    value: "Africa/Lagos",
  },
  {
    title: "Africa/Libreville (GMT+01:00)",
    value: "Africa/Libreville",
  },
  {
    title: "Africa/Luanda (GMT+01:00)",
    value: "Africa/Luanda",
  },
  {
    title: "Africa/Malabo (GMT+01:00)",
    value: "Africa/Malabo",
  },
  {
    title: "Africa/Ndjamena (GMT+01:00)",
    value: "Africa/Ndjamena",
  },
  {
    title: "Africa/Niamey (GMT+01:00)",
    value: "Africa/Niamey",
  },
  {
    title: "Africa/Porto-Novo (GMT+01:00)",
    value: "Africa/Porto-Novo",
  },
  {
    title: "Africa/Tunis (GMT+01:00)",
    value: "Africa/Tunis",
  },
  {
    title: "Africa/Windhoek (GMT+01:00)",
    value: "Africa/Windhoek",
  },
  {
    title: "Arctic/Longyearbyen (GMT+01:00)",
    value: "Arctic/Longyearbyen",
  },
  {
    title: "Europe/Amsterdam (GMT+01:00)",
    value: "Europe/Amsterdam",
  },
  {
    title: "Europe/Andorra (GMT+01:00)",
    value: "Europe/Andorra",
  },
  {
    title: "Europe/Belgrade (GMT+01:00)",
    value: "Europe/Belgrade",
  },
  {
    title: "Europe/Berlin (GMT+01:00)",
    value: "Europe/Berlin",
  },
  {
    title: "Europe/Bratislava (GMT+01:00)",
    value: "Europe/Bratislava",
  },
  {
    title: "Europe/Brussels (GMT+01:00)",
    value: "Europe/Brussels",
  },
  {
    title: "Europe/Budapest (GMT+01:00)",
    value: "Europe/Budapest",
  },
  {
    title: "Europe/Copenhagen (GMT+01:00)",
    value: "Europe/Copenhagen",
  },
  {
    title: "Europe/Gibraltar (GMT+01:00)",
    value: "Europe/Gibraltar",
  },
  {
    title: "Europe/Ljubljana (GMT+01:00)",
    value: "Europe/Ljubljana",
  },
  {
    title: "Europe/Luxembourg (GMT+01:00)",
    value: "Europe/Luxembourg",
  },
  {
    title: "Europe/Madrid (GMT+01:00)",
    value: "Europe/Madrid",
  },
  {
    title: "Europe/Malta (GMT+01:00)",
    value: "Europe/Malta",
  },
  {
    title: "Europe/Monaco (GMT+01:00)",
    value: "Europe/Monaco",
  },
  {
    title: "Europe/Oslo (GMT+01:00)",
    value: "Europe/Oslo",
  },
  {
    title: "Europe/Paris (GMT+01:00)",
    value: "Europe/Paris",
  },
  {
    title: "Europe/Podgorica (GMT+01:00)",
    value: "Europe/Podgorica",
  },
  {
    title: "Europe/Prague (GMT+01:00)",
    value: "Europe/Prague",
  },
  {
    title: "Europe/Rome (GMT+01:00)",
    value: "Europe/Rome",
  },
  {
    title: "Europe/San_Marino (GMT+01:00)",
    value: "Europe/San_Marino",
  },
  {
    title: "Europe/Sarajevo (GMT+01:00)",
    value: "Europe/Sarajevo",
  },
  {
    title: "Europe/Skopje (GMT+01:00)",
    value: "Europe/Skopje",
  },
  {
    title: "Europe/Stockholm (GMT+01:00)",
    value: "Europe/Stockholm",
  },
  {
    title: "Europe/Tirane (GMT+01:00)",
    value: "Europe/Tirane",
  },
  {
    title: "Europe/Vaduz (GMT+01:00)",
    value: "Europe/Vaduz",
  },
  {
    title: "Europe/Vatican (GMT+01:00)",
    value: "Europe/Vatican",
  },
  {
    title: "Europe/Vienna (GMT+01:00)",
    value: "Europe/Vienna",
  },
  {
    title: "Europe/Warsaw (GMT+01:00)",
    value: "Europe/Warsaw",
  },
  {
    title: "Europe/Zagreb (GMT+01:00)",
    value: "Europe/Zagreb",
  },
  {
    title: "Europe/Zurich (GMT+01:00)",
    value: "Europe/Zurich",
  },
  {
    title: "Africa/Blantyre (GMT+02:00)",
    value: "Africa/Blantyre",
  },
  {
    title: "Africa/Bujumbura (GMT+02:00)",
    value: "Africa/Bujumbura",
  },
  {
    title: "Africa/Cairo (GMT+02:00)",
    value: "Africa/Cairo",
  },
  {
    title: "Africa/Gaborone (GMT+02:00)",
    value: "Africa/Gaborone",
  },
  {
    title: "Africa/Harare (GMT+02:00)",
    value: "Africa/Harare",
  },
  {
    title: "Africa/Johannesburg (GMT+02:00)",
    value: "Africa/Johannesburg",
  },
  {
    title: "Africa/Juba (GMT+02:00)",
    value: "Africa/Juba",
  },
  {
    title: "Africa/Khartoum (GMT+02:00)",
    value: "Africa/Khartoum",
  },
  {
    title: "Africa/Kigali (GMT+02:00)",
    value: "Africa/Kigali",
  },
  {
    title: "Africa/Lubumbashi (GMT+02:00)",
    value: "Africa/Lubumbashi",
  },
  {
    title: "Africa/Lusaka (GMT+02:00)",
    value: "Africa/Lusaka",
  },
  {
    title: "Africa/Maputo (GMT+02:00)",
    value: "Africa/Maputo",
  },
  {
    title: "Africa/Maseru (GMT+02:00)",
    value: "Africa/Maseru",
  },
  {
    title: "Africa/Mbabane (GMT+02:00)",
    value: "Africa/Mbabane",
  },
  {
    title: "Africa/Tripoli (GMT+02:00)",
    value: "Africa/Tripoli",
  },
  {
    title: "Asia/Amman (GMT+02:00)",
    value: "Asia/Amman",
  },
  {
    title: "Asia/Beirut (GMT+02:00)",
    value: "Asia/Beirut",
  },
  {
    title: "Asia/Damascus (GMT+02:00)",
    value: "Asia/Damascus",
  },
  {
    title: "Asia/Famagusta (GMT+02:00)",
    value: "Asia/Famagusta",
  },
  {
    title: "Asia/Gaza (GMT+02:00)",
    value: "Asia/Gaza",
  },
  {
    title: "Asia/Hebron (GMT+02:00)",
    value: "Asia/Hebron",
  },
  {
    title: "Asia/Jerusalem (GMT+02:00)",
    value: "Asia/Jerusalem",
  },
  {
    title: "Asia/Nicosia (GMT+02:00)",
    value: "Asia/Nicosia",
  },
  {
    title: "Europe/Athens (GMT+02:00)",
    value: "Europe/Athens",
  },
  {
    title: "Europe/Bucharest (GMT+02:00)",
    value: "Europe/Bucharest",
  },
  {
    title: "Europe/Chisinau (GMT+02:00)",
    value: "Europe/Chisinau",
  },
  {
    title: "Europe/Helsinki (GMT+02:00)",
    value: "Europe/Helsinki",
  },
  {
    title: "Europe/Kaliningrad (GMT+02:00)",
    value: "Europe/Kaliningrad",
  },
  {
    title: "Europe/Kyiv (GMT+02:00)",
    value: "Europe/Kyiv",
  },
  {
    title: "Europe/Mariehamn (GMT+02:00)",
    value: "Europe/Mariehamn",
  },
  {
    title: "Europe/Riga (GMT+02:00)",
    value: "Europe/Riga",
  },
  {
    title: "Europe/Sofia (GMT+02:00)",
    value: "Europe/Sofia",
  },
  {
    title: "Europe/Tallinn (GMT+02:00)",
    value: "Europe/Tallinn",
  },
  {
    title: "Europe/Uzhgorod (GMT+02:00)",
    value: "Europe/Uzhgorod",
  },
  {
    title: "Europe/Vilnius (GMT+02:00)",
    value: "Europe/Vilnius",
  },
  {
    title: "Europe/Zaporizhzhia (GMT+02:00)",
    value: "Europe/Zaporizhzhia",
  },
  {
    title: "Africa/Addis_Ababa (GMT+03:00)",
    value: "Africa/Addis_Ababa",
  },
  {
    title: "Africa/Asmara (GMT+03:00)",
    value: "Africa/Asmara",
  },
  {
    title: "Africa/Dar_es_Salaam (GMT+03:00)",
    value: "Africa/Dar_es_Salaam",
  },
  {
    title: "Africa/Djibouti (GMT+03:00)",
    value: "Africa/Djibouti",
  },
  {
    title: "Africa/Kampala (GMT+03:00)",
    value: "Africa/Kampala",
  },
  {
    title: "Africa/Mogadishu (GMT+03:00)",
    value: "Africa/Mogadishu",
  },
  {
    title: "Africa/Nairobi (GMT+03:00)",
    value: "Africa/Nairobi",
  },
  {
    title: "Antarctica/Syowa (GMT+03:00)",
    value: "Antarctica/Syowa",
  },
  {
    title: "Asia/Aden (GMT+03:00)",
    value: "Asia/Aden",
  },
  {
    title: "Asia/Baghdad (GMT+03:00)",
    value: "Asia/Baghdad",
  },
  {
    title: "Asia/Bahrain (GMT+03:00)",
    value: "Asia/Bahrain",
  },
  {
    title: "Asia/Kuwait (GMT+03:00)",
    value: "Asia/Kuwait",
  },
  {
    title: "Asia/Qatar (GMT+03:00)",
    value: "Asia/Qatar",
  },
  {
    title: "Asia/Riyadh (GMT+03:00)",
    value: "Asia/Riyadh",
  },
  {
    title: "Europe/Istanbul (GMT+03:00)",
    value: "Europe/Istanbul",
  },
  {
    title: "Europe/Kirov (GMT+03:00)",
    value: "Europe/Kirov",
  },
  {
    title: "Europe/Minsk (GMT+03:00)",
    value: "Europe/Minsk",
  },
  {
    title: "Europe/Moscow (GMT+03:00)",
    value: "Europe/Moscow",
  },
  {
    title: "Europe/Simferopol (GMT+03:00)",
    value: "Europe/Simferopol",
  },
  {
    title: "Europe/Volgograd (GMT+03:00)",
    value: "Europe/Volgograd",
  },
  {
    title: "Indian/Antananarivo (GMT+03:00)",
    value: "Indian/Antananarivo",
  },
  {
    title: "Indian/Comoro (GMT+03:00)",
    value: "Indian/Comoro",
  },
  {
    title: "Indian/Mayotte (GMT+03:00)",
    value: "Indian/Mayotte",
  },
  {
    title: "Asia/Tehran (GMT+03:30)",
    value: "Asia/Tehran",
  },
  {
    title: "Asia/Baku (GMT+04:00)",
    value: "Asia/Baku",
  },
  {
    title: "Asia/Dubai (GMT+04:00)",
    value: "Asia/Dubai",
  },
  {
    title: "Asia/Muscat (GMT+04:00)",
    value: "Asia/Muscat",
  },
  {
    title: "Asia/Tbilisi (GMT+04:00)",
    value: "Asia/Tbilisi",
  },
  {
    title: "Asia/Yerevan (GMT+04:00)",
    value: "Asia/Yerevan",
  },
  {
    title: "Europe/Astrakhan (GMT+04:00)",
    value: "Europe/Astrakhan",
  },
  {
    title: "Europe/Samara (GMT+04:00)",
    value: "Europe/Samara",
  },
  {
    title: "Europe/Saratov (GMT+04:00)",
    value: "Europe/Saratov",
  },
  {
    title: "Europe/Ulyanovsk (GMT+04:00)",
    value: "Europe/Ulyanovsk",
  },
  {
    title: "Indian/Mahe (GMT+04:00)",
    value: "Indian/Mahe",
  },
  {
    title: "Indian/Mauritius (GMT+04:00)",
    value: "Indian/Mauritius",
  },
  {
    title: "Indian/Reunion (GMT+04:00)",
    value: "Indian/Reunion",
  },
  {
    title: "Asia/Kabul (GMT+04:30)",
    value: "Asia/Kabul",
  },
  {
    title: "Antarctica/Mawson (GMT+05:00)",
    value: "Antarctica/Mawson",
  },
  {
    title: "Asia/Aqtau (GMT+05:00)",
    value: "Asia/Aqtau",
  },
  {
    title: "Asia/Aqtobe (GMT+05:00)",
    value: "Asia/Aqtobe",
  },
  {
    title: "Asia/Ashgabat (GMT+05:00)",
    value: "Asia/Ashgabat",
  },
  {
    title: "Asia/Atyrau (GMT+05:00)",
    value: "Asia/Atyrau",
  },
  {
    title: "Asia/Dushanbe (GMT+05:00)",
    value: "Asia/Dushanbe",
  },
  {
    title: "Asia/Karachi (GMT+05:00)",
    value: "Asia/Karachi",
  },
  {
    title: "Asia/Oral (GMT+05:00)",
    value: "Asia/Oral",
  },
  {
    title: "Asia/Qyzylorda (GMT+05:00)",
    value: "Asia/Qyzylorda",
  },
  {
    title: "Asia/Samarkand (GMT+05:00)",
    value: "Asia/Samarkand",
  },
  {
    title: "Asia/Tashkent (GMT+05:00)",
    value: "Asia/Tashkent",
  },
  {
    title: "Asia/Yekaterinburg (GMT+05:00)",
    value: "Asia/Yekaterinburg",
  },
  {
    title: "Indian/Kerguelen (GMT+05:00)",
    value: "Indian/Kerguelen",
  },
  {
    title: "Indian/Maldives (GMT+05:00)",
    value: "Indian/Maldives",
  },
  {
    title: "Asia/Colombo (GMT+05:30)",
    value: "Asia/Colombo",
  },
  {
    title: "Asia/Kolkata (GMT+05:30)",
    value: "Asia/Kolkata",
  },
  {
    title: "Asia/Kathmandu (GMT+05:45)",
    value: "Asia/Kathmandu",
  },
  {
    title: "Antarctica/Vostok (GMT+06:00)",
    value: "Antarctica/Vostok",
  },
  {
    title: "Asia/Almaty (GMT+05:00)",
    value: "Asia/Almaty",
  },
  {
    title: "Asia/Bishkek (GMT+06:00)",
    value: "Asia/Bishkek",
  },
  {
    title: "Asia/Dhaka (GMT+06:00)",
    value: "Asia/Dhaka",
  },
  {
    title: "Asia/Omsk (GMT+06:00)",
    value: "Asia/Omsk",
  },
  {
    title: "Asia/Qostanay (GMT+06:00)",
    value: "Asia/Qostanay",
  },
  {
    title: "Asia/Thimphu (GMT+06:00)",
    value: "Asia/Thimphu",
  },
  {
    title: "Asia/Urumqi (GMT+06:00)",
    value: "Asia/Urumqi",
  },
  {
    title: "Indian/Chagos (GMT+06:00)",
    value: "Indian/Chagos",
  },
  {
    title: "Asia/Yangon (GMT+06:30)",
    value: "Asia/Yangon",
  },
  {
    title: "Indian/Cocos (GMT+06:30)",
    value: "Indian/Cocos",
  },
  {
    title: "Antarctica/Davis (GMT+07:00)",
    value: "Antarctica/Davis",
  },
  {
    title: "Asia/Bangkok (GMT+07:00)",
    value: "Asia/Bangkok",
  },
  {
    title: "Asia/Barnaul (GMT+07:00)",
    value: "Asia/Barnaul",
  },
  {
    title: "Asia/Hovd (GMT+07:00)",
    value: "Asia/Hovd",
  },
  {
    title: "Asia/Ho_Chi_Minh (GMT+07:00)",
    value: "Asia/Ho_Chi_Minh",
  },
  {
    title: "Asia/Jakarta (GMT+07:00)",
    value: "Asia/Jakarta",
  },
  {
    title: "Asia/Krasnoyarsk (GMT+07:00)",
    value: "Asia/Krasnoyarsk",
  },
  {
    title: "Asia/Novokuznetsk (GMT+07:00)",
    value: "Asia/Novokuznetsk",
  },
  {
    title: "Asia/Novosibirsk (GMT+07:00)",
    value: "Asia/Novosibirsk",
  },
  {
    title: "Asia/Phnom_Penh (GMT+07:00)",
    value: "Asia/Phnom_Penh",
  },
  {
    title: "Asia/Pontianak (GMT+07:00)",
    value: "Asia/Pontianak",
  },
  {
    title: "Asia/Tomsk (GMT+07:00)",
    value: "Asia/Tomsk",
  },
  {
    title: "Asia/Vientiane (GMT+07:00)",
    value: "Asia/Vientiane",
  },
  {
    title: "Indian/Christmas (GMT+07:00)",
    value: "Indian/Christmas",
  },
  {
    title: "Asia/Brunei (GMT+08:00)",
    value: "Asia/Brunei",
  },
  {
    title: "Asia/Choibalsan (GMT+08:00)",
    value: "Asia/Choibalsan",
  },
  {
    title: "Asia/Hong_Kong (GMT+08:00)",
    value: "Asia/Hong_Kong",
  },
  {
    title: "Asia/Irkutsk (GMT+08:00)",
    value: "Asia/Irkutsk",
  },
  {
    title: "Asia/Kuala_Lumpur (GMT+08:00)",
    value: "Asia/Kuala_Lumpur",
  },
  {
    title: "Asia/Kuching (GMT+08:00)",
    value: "Asia/Kuching",
  },
  {
    title: "Asia/Macau (GMT+08:00)",
    value: "Asia/Macau",
  },
  {
    title: "Asia/Makassar (GMT+08:00)",
    value: "Asia/Makassar",
  },
  {
    title: "Asia/Manila (GMT+08:00)",
    value: "Asia/Manila",
  },
  {
    title: "Asia/Shanghai (GMT+08:00)",
    value: "Asia/Shanghai",
  },
  {
    title: "Asia/Singapore (GMT+08:00)",
    value: "Asia/Singapore",
  },
  {
    title: "Asia/Taipei (GMT+08:00)",
    value: "Asia/Taipei",
  },
  {
    title: "Asia/Ulaanbaatar (GMT+08:00)",
    value: "Asia/Ulaanbaatar",
  },
  {
    title: "Australia/Perth (GMT+08:00)",
    value: "Australia/Perth",
  },
  {
    title: "Australia/Eucla (GMT+08:45)",
    value: "Australia/Eucla",
  },
  {
    title: "Asia/Chita (GMT+09:00)",
    value: "Asia/Chita",
  },
  {
    title: "Asia/Dili (GMT+09:00)",
    value: "Asia/Dili",
  },
  {
    title: "Asia/Jayapura (GMT+09:00)",
    value: "Asia/Jayapura",
  },
  {
    title: "Asia/Khandyga (GMT+09:00)",
    value: "Asia/Khandyga",
  },
  {
    title: "Asia/Pyongyang (GMT+09:00)",
    value: "Asia/Pyongyang",
  },
  {
    title: "Asia/Seoul (GMT+09:00)",
    value: "Asia/Seoul",
  },
  {
    title: "Asia/Tokyo (GMT+09:00)",
    value: "Asia/Tokyo",
  },
  {
    title: "Asia/Yakutsk (GMT+09:00)",
    value: "Asia/Yakutsk",
  },
  {
    title: "Pacific/Palau (GMT+09:00)",
    value: "Pacific/Palau",
  },
  {
    title: "Australia/Adelaide (GMT+09:30)",
    value: "Australia/Adelaide",
  },
  {
    title: "Australia/Broken_Hill (GMT+09:30)",
    value: "Australia/Broken_Hill",
  },
  {
    title: "Australia/Darwin (GMT+09:30)",
    value: "Australia/Darwin",
  },
  {
    title: "Antarctica/DumontDUrville (GMT+10:00)",
    value: "Antarctica/DumontDUrville",
  },
  {
    title: "Antarctica/Macquarie (GMT+10:00)",
    value: "Antarctica/Macquarie",
  },
  {
    title: "Asia/Ust-Nera (GMT+10:00)",
    value: "Asia/Ust-Nera",
  },
  {
    title: "Asia/Vladivostok (GMT+10:00)",
    value: "Asia/Vladivostok",
  },
  {
    title: "Australia/Brisbane (GMT+10:00)",
    value: "Australia/Brisbane",
  },
  {
    title: "Australia/Currie (GMT+10:00)",
    value: "Australia/Currie",
  },
  {
    title: "Australia/Hobart (GMT+10:00)",
    value: "Australia/Hobart",
  },
  {
    title: "Australia/Lindeman (GMT+10:00)",
    value: "Australia/Lindeman",
  },
  {
    title: "Australia/Melbourne (GMT+10:00)",
    value: "Australia/Melbourne",
  },
  {
    title: "Australia/Sydney (GMT+10:00)",
    value: "Australia/Sydney",
  },
  {
    title: "Pacific/Chuuk (GMT+10:00)",
    value: "Pacific/Chuuk",
  },
  {
    title: "Pacific/Guam (GMT+10:00)",
    value: "Pacific/Guam",
  },
  {
    title: "Pacific/Port_Moresby (GMT+10:00)",
    value: "Pacific/Port_Moresby",
  },
  {
    title: "Pacific/Saipan (GMT+10:00)",
    value: "Pacific/Saipan",
  },
  {
    title: "Australia/Lord_Howe (GMT+10:30)",
    value: "Australia/Lord_Howe",
  },
  {
    title: "Antarctica/Casey (GMT+8:00)",
    value: "Antarctica/Casey",
  },
  {
    title: "Asia/Magadan (GMT+11:00)",
    value: "Asia/Magadan",
  },
  {
    title: "Asia/Sakhalin (GMT+11:00)",
    value: "Asia/Sakhalin",
  },
  {
    title: "Asia/Srednekolymsk (GMT+11:00)",
    value: "Asia/Srednekolymsk",
  },
  {
    title: "Pacific/Bougainville (GMT+11:00)",
    value: "Pacific/Bougainville",
  },
  {
    title: "Pacific/Efate (GMT+11:00)",
    value: "Pacific/Efate",
  },
  {
    title: "Pacific/Guadalcanal (GMT+11:00)",
    value: "Pacific/Guadalcanal",
  },
  {
    title: "Pacific/Kosrae (GMT+11:00)",
    value: "Pacific/Kosrae",
  },
  {
    title: "Pacific/Norfolk (GMT+11:00)",
    value: "Pacific/Norfolk",
  },
  {
    title: "Pacific/Noumea (GMT+11:00)",
    value: "Pacific/Noumea",
  },
  {
    title: "Pacific/Pohnpei (GMT+11:00)",
    value: "Pacific/Pohnpei",
  },
  {
    title: "Antarctica/McMurdo (GMT+12:00)",
    value: "Antarctica/McMurdo",
  },
  {
    title: "Asia/Anadyr (GMT+12:00)",
    value: "Asia/Anadyr",
  },
  {
    title: "Asia/Kamchatka (GMT+12:00)",
    value: "Asia/Kamchatka",
  },
  {
    title: "Pacific/Auckland (GMT+12:00)",
    value: "Pacific/Auckland",
  },
  {
    title: "Pacific/Fiji (GMT+12:00)",
    value: "Pacific/Fiji",
  },
  {
    title: "Pacific/Funafuti (GMT+12:00)",
    value: "Pacific/Funafuti",
  },
  {
    title: "Pacific/Kwajalein (GMT+12:00)",
    value: "Pacific/Kwajalein",
  },
  {
    title: "Pacific/Majuro (GMT+12:00)",
    value: "Pacific/Majuro",
  },
  {
    title: "Pacific/Nauru (GMT+12:00)",
    value: "Pacific/Nauru",
  },
  {
    title: "Pacific/Tarawa (GMT+12:00)",
    value: "Pacific/Tarawa",
  },
  {
    title: "Pacific/Wake (GMT+12:00)",
    value: "Pacific/Wake",
  },
  {
    title: "Pacific/Wallis (GMT+12:00)",
    value: "Pacific/Wallis",
  },
  {
    title: "Pacific/Chatham (GMT+12:45)",
    value: "Pacific/Chatham",
  },
  {
    title: "Pacific/Apia (GMT+13:00)",
    value: "Pacific/Apia",
  },
  {
    title: "Pacific/Enderbury (GMT+13:00)",
    value: "Pacific/Enderbury",
  },
  {
    title: "Pacific/Fakaofo (GMT+13:00)",
    value: "Pacific/Fakaofo",
  },
  {
    title: "Pacific/Tongatapu (GMT+13:00)",
    value: "Pacific/Tongatapu",
  },
  {
    title: "Pacific/Kiritimati (GMT+14:00)",
    value: "Pacific/Kiritimati",
  },
];
